import styled from "styled-components";
import { smallMediaBreakpoint, spacingS } from "@RooUI";

export const BookingConfirmedContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  gap: 52px;
  @media (max-width: ${smallMediaBreakpoint}) {
    padding: 0 32px;
  }
  img {
    width: 452px;
    height: auto;
  }
  div {
    max-width: 568px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    text-align: center;
    gap: ${spacingS};
  }
`;
